"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-MultiListChooser',
    filter: 'c-MultiListChooser__filter',
    chooserContainer: 'c-MultiListChooser__container',
    title: 'c-MultiListChooser__title',
    group: {
        container: 'c-MultiListChooser__group',
        title: 'c-MultiListChooser__groupTitle',
        selectionWrap: 'c-MultiListChooser__groupSelectWrap',
        selection: 'c-MultiListChooser__groupSelect',
    },
    modal: 'c-MultiListChooser__modal',
    colorIndicator: 'c-MultiListChooser__colorIndicator',
};
exports.Style = {
    [exports.CSS.title]: {
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
    },
    [exports.CSS.container]: {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'flex-direction': 'column',
    },
    [exports.CSS.chooserContainer]: {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        width: '100%',
    },
    [exports.CSS.group.container]: {
        width: '100%',
        height: '240px',
        display: 'flex',
        'flex-direction': 'column',
    },
    [exports.CSS.group.title]: {
        'font-family': theme_1.DefaultTheme.font.familyCondensed,
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
        'padding-bottom': theme_1.DefaultTheme.space(4),
    },
    [exports.CSS.group.selectionWrap]: {
        'background-color': theme_1.DefaultTheme.background.grey,
        flex: 1,
        overflow: 'auto',
    },
    [`${exports.CSS.group.container}:nth-child(even) .${exports.CSS.group.selectionWrap}`]: {
        'background-color': theme_1.DefaultTheme.background.lightGrey,
    },
    [exports.CSS.group.selection]: {
        position: 'relative',
        display: 'flex',
        '&:hover': {
            'background-color': theme_1.DefaultTheme.font.color.divider,
        },
        '& input': {
            appearance: 'none',
            '&::-ms-check': {
                display: 'none', // Hide radio button for IE11
            },
            position: 'absolute',
        },
        '& input + label': {
            width: '100%',
            'border-left': `${theme_1.DefaultTheme.space(1)} solid transparent`,
            'padding-left': theme_1.DefaultTheme.space(1),
        },
        '& input:focus + label': {
            outline: `1px solid ${theme_1.DefaultTheme.color.accent}`,
            'margin-right': '1px',
        },
        '& input:checked + label': {
            'background-color': theme_1.DefaultTheme.background.offWhite,
            'border-left': `${theme_1.DefaultTheme.space(1)} solid ${theme_1.DefaultTheme.color.accent}`,
            'padding-left': theme_1.DefaultTheme.space(1),
            'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        },
    },
    [exports.CSS.modal]: {
        'min-width': '800px',
    },
    [exports.CSS.filter]: {
        display: 'flex',
        width: '100%',
        'padding-bottom': theme_1.DefaultTheme.space(4),
        '& input:hover': {
            'background-color': theme_1.DefaultTheme.font.color.divider,
        },
        '& input': {
            width: '100%',
            border: `${theme_1.DefaultTheme.space(1)} solid transparent`,
            'padding-left': theme_1.DefaultTheme.space(1),
        },
        '& input:focus': {
            outline: `1px solid ${theme_1.DefaultTheme.color.accent}`,
            'margin-right': '1px',
        },
        '& input:checked': {
            'background-color': theme_1.DefaultTheme.background.offWhite,
            'border-left': `${theme_1.DefaultTheme.space(1)} solid ${theme_1.DefaultTheme.color.accent}`,
            'padding-left': theme_1.DefaultTheme.space(1),
            'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        },
    },
    [exports.CSS.colorIndicator]: {
        width: '12px',
        height: '12px',
        position: 'absolute',
        top: '50%',
        right: '4px',
        transform: 'translateY(-50%)',
        borderRadius: '50%',
    },
};
//# sourceMappingURL=multi.list.chooser.style.js.map